import { useState, type VoidFunctionComponent } from 'react';
import type { DependencyMetadataFilterOption, FormatName, IncludeFilterOption, SBOMFormat } from './shared/types';
import { ReportCategories } from '../ReportGeneration/utils';
import type { FormatSelection, OnApply } from './shared/components/Filter';
import Filter from './shared/components/Filter';
import type { SetState } from '../../../../types';

type SBOMFiltersProps = {
  onApply: OnApply;
  appliedFormat: FormatName | null;
  includeOptions: IncludeFilterOption[];
  dependencyMetadataOptions: DependencyMetadataFilterOption[];
  setIsDirty: SetState<boolean>;
  isApplyButtonDisabled: boolean;
};

const SBOMFilters: VoidFunctionComponent<SBOMFiltersProps> = ({
  onApply,
  appliedFormat,
  includeOptions,
  dependencyMetadataOptions,
  setIsDirty,
  isApplyButtonDisabled,
}) => {
  const spdxFormat: SBOMFormat = { label: 'SPDX', value: 'SPDX' };
  const formats: SBOMFormat[] = [
    spdxFormat,
    { label: 'SPDX (JSON)', value: 'SPDX (JSON)' },
    { label: 'CycloneDX (JSON)', value: 'CycloneDX (JSON)' },
    { label: 'CycloneDX (XML)', value: 'CycloneDX (XML)' },
  ];
  const [format, setFormat] = useState<FormatSelection>(spdxFormat);
  return (
    <Filter
      isApplyButtonDisabled={isApplyButtonDisabled}
      setIsDirty={setIsDirty}
      includeOptions={includeOptions}
      dependencyMetadataOptions={dependencyMetadataOptions}
      category={ReportCategories.SBOM}
      appliedFormat={appliedFormat}
      format={format}
      setFormat={setFormat}
      formats={formats}
      onApply={onApply}
    />
  );
};

export default SBOMFilters;
